var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "box" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "margin-left": "25px", "margin-right": "25px" }
    }),
    _vm._v(" "),
    _c("table", [
      _c("tr", [
        _vm._m(1),
        _vm._v(" "),
        _c("td", { staticStyle: { width: "100%" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.username,
                expression: "username"
              }
            ],
            staticClass: "textfield",
            attrs: { id: "username", type: "username" },
            domProps: { value: _vm.username },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.username = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm._m(2)
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(3),
        _vm._v(" "),
        _c("td", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name"
              }
            ],
            staticClass: "textfield",
            attrs: { type: "text" },
            domProps: { value: _vm.name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.name = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(4),
        _vm._v(" "),
        _c("td", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.company,
                expression: "company"
              }
            ],
            staticClass: "textfield",
            attrs: { type: "text" },
            domProps: { value: _vm.company },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.company = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(5),
        _vm._v(" "),
        _c("td", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.position,
                expression: "position"
              }
            ],
            staticClass: "textfield",
            attrs: { type: "text" },
            domProps: { value: _vm.position },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.position = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(6),
        _vm._v(" "),
        _c("td", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone"
              }
            ],
            staticClass: "textfield",
            attrs: { type: "tel" },
            domProps: { value: _vm.phone },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.phone = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(7),
        _vm._v(" "),
        _c("td", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.email,
                expression: "email"
              }
            ],
            staticClass: "textfield",
            attrs: { type: "email" },
            domProps: { value: _vm.email },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.email = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(8),
        _vm._v(" "),
        _c("td", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.password,
                expression: "password"
              }
            ],
            staticClass: "textfield",
            attrs: { type: "password" },
            domProps: { value: _vm.password },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.password = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm._m(9)
      ]),
      _vm._v(" "),
      _c("tr", [
        _vm._m(10),
        _vm._v(" "),
        _c("td", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.repassword,
                expression: "repassword"
              }
            ],
            staticClass: "textfield",
            attrs: { type: "password" },
            domProps: { value: _vm.repassword },
            on: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.signup()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.repassword = $event.target.value
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c(
        "button",
        {
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.cancel()
            }
          }
        },
        [_vm._v("Cancel")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.signup()
            }
          }
        },
        [_vm._v("Register")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("p", { staticClass: "title" }, [_vm._v("Register")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("p", { staticClass: "textlabel" }, [_vm._v("Username")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("p", { staticClass: "smalltext" }, [_vm._v("(6 characters minimum)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("p", { staticClass: "textlabel" }, [_vm._v("Full Name")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("p", { staticClass: "textlabel" }, [_vm._v("Company")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("p", { staticClass: "textlabel" }, [_vm._v("Position")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("p", { staticClass: "textlabel" }, [_vm._v("Phone Number")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("p", { staticClass: "textlabel" }, [_vm._v("Email")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("p", { staticClass: "textlabel" }, [_vm._v("Password")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { staticClass: "smalltext" }, [
        _vm._v("(8 characters minimum)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("p", { staticClass: "textlabel" }, [_vm._v("Retype Password")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1469446a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1469446a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/file/Signup.vue
// module id = 491
// module chunks = 0